import styled from "styled-components";
export const Card = styled.div`
  width: 250px;
  height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  box-shadow: 0px 2px 14px 15px rgba(102, 167, 196, 0.07);
  border-radius: 10px;
  background-color: ${({ theme: { colors } }) => colors.white};
`;
export const CompanyLogo = styled.img`
  width: 90px;
  height: 90px;
  object-fit: contain;
  margin-bottom: 1.5rem;
`;
export const CompanyName = styled.span`
  align-self: flex-start;
  font-size: 1rem;
  font-weight: 500;
`;
export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;
`;
